export const categoryKeys = {
  all: ["categories"] as const,
  lists: () => [...categoryKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...categoryKeys.lists(), params] as const,
  details: () => [...categoryKeys.all, "detail"] as const,
  detail: (id: string) => [...categoryKeys.details(), id] as const,
  tree: () => [...categoryKeys.all, "tree"] as const,
  /** Superadmin categories the store hasn't pulled in yet. Invalidated by a
   *  successful sync — the just-synced nodes drop out of the next response,
   *  which is what stops them being picked twice. */
  syncAvailable: () => [...categoryKeys.all, "sync-available"] as const,
  effectivePreset: (categoryId: string) =>
    [...categoryKeys.all, "effective-preset", categoryId] as const,
};
